import MuiCircularProgress, {
  CircularProgressProps
} from '@mui/material/CircularProgress';

export interface ICircularProgressProps extends CircularProgressProps {}

const CircularProgress = (props: ICircularProgressProps): JSX.Element => {
  return <MuiCircularProgress {...props} />;
};

export default CircularProgress;
